export interface IComboBetPickState {
    isSelected: boolean;
    isLocked: boolean;
}

export interface IComboBetState {
    picks: { [pickId: string]: IComboBetPickState };
    isEachWay: boolean;
    stake: number | null;
    rewardTokenId: string | null;
    actualStake: string | null;
}

export const defaultComboBetState: IComboBetState = {
    picks: {},
    isEachWay: false,
    stake: null,
    rewardTokenId: '',
    actualStake: null,
};
